import { render } from "./ProductClassItemList.vue?vue&type=template&id=07820d78&scoped=true&ts=true"
import script from "./ProductClassItemList.vue?vue&type=script&lang=ts"
export * from "./ProductClassItemList.vue?vue&type=script&lang=ts"

import "./ProductClassItemList.vue?vue&type=style&index=0&id=07820d78&lang=scss&scoped=true"
import "./ProductClassItemList.vue?vue&type=style&index=1&id=07820d78&lang=postcss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07820d78"]])

export default __exports__